module.exports = __webpack_public_path__ + "img/defaultProductIco2.3466f297.png";